export function VerifyEmail(text) {
    return (/([a-z]|[0-9]|[.])*@[a-z]([a-z]|[0-9]|[.])*[.](com|org|net)/i.test(text) && !text.includes(" "));
}

export function VerifyNumber(text) {
    return (!(/[^0-9]/.test(text)) && /[0-9]/.test(text));
}